document.addEventListener('DOMContentLoaded', function (){
    const customSwatches = document.querySelector('.custom-swatches');

    if(customSwatches && !customSwatches.classList.contains('custom-multicolor-swatches')){
        const legendSelected = document.querySelectorAll('.radio__legend__label-selected');
        const customRadios = document.querySelectorAll('.custom-swatches__radio');

        customRadios.forEach(function (item){
            item.addEventListener('change', function (event){
                const optionValue = event.target.dataset.option;

                showSelectedColor(optionValue);
            })
        })

        legendSelected.forEach(function (item){
            showSelectedColor(item.dataset.option);
        })
    }

    if (customSwatches && customSwatches.classList.contains('custom-multicolor-swatches')) {
        const customRadios = document.querySelectorAll('.custom-swatches__radio');

        customRadios.forEach(function (item){
            item.addEventListener('change', function (){
                setHiddenColorField();
            })
        })

        setHiddenColorField();
    }

    function setHiddenColorField() {
        const selectedColorInputs = document.querySelectorAll('.custom-color-swatches__radio:checked');
        const colorCount = selectedColorInputs.length;
        let resultValue = '';
        let iterationCounter = 1;

        selectedColorInputs.forEach(function (item){
            resultValue += item.value

            if (colorCount !== iterationCounter) {
                resultValue += ', ';
            }

            iterationCounter++;
        })

        document.getElementById('hidden-color-field').value = resultValue;

        showSelectedMulticolor(resultValue);
    }

    function showSelectedColor(optionValue){
        let selectedColor = document.querySelector(`.custom-swatches__radio[data-option="${optionValue}"]:checked`).value;

        document.querySelector(`.radio__legend__label-selected[data-option="${optionValue}"]`).textContent = selectedColor;
    }

    function showSelectedMulticolor(value){
        document.querySelector(`.radio__legend__label-selected[data-option="Color"]`).textContent = value;
    }
})
